import { Component, Input } from '@angular/core';
import { QaiCarouselComponent, QaiCarouselItemDirective } from '@qai/ui';
import { IFlattenedMessageAdherenceSection } from 'src/app/interfaces/iflattenedMessageAdherenceSection';
import { IObjectiveConversational } from 'src/app/interfaces/iobjective-conversational';
import { IResultsConversational } from 'src/app/interfaces/iresults-conversational';
import { IScoreMessageAdherence } from 'src/app/interfaces/iscore-message-adherence';
import { IScoreOverallConversational } from 'src/app/interfaces/iscore-overall-conversational';
import { ScoreArrayItem } from 'src/app/utils/enums/result/resultConversational.enum';
import { ResultOverallScoreComponent } from './result-overall-score/result-overall-score.component';

@Component({
  selector: 'app-results-pathway-roleplay',
  standalone: true,
  imports: [QaiCarouselComponent, QaiCarouselItemDirective, ResultOverallScoreComponent],
  templateUrl: './results-pathway-roleplay.component.html',
  styleUrls: ['./results-pathway-roleplay.component.scss'],
})
export class ResultsPathwayRoleplayComponent {
  @Input() conversationalResults: IResultsConversational | undefined;
  @Input() scoreOverall: IScoreOverallConversational | undefined;
  @Input() scoresArray: ScoreArrayItem[] = [];
  @Input() objectives: IObjectiveConversational[] | undefined;
  @Input() scoreMessageAdherence: IScoreMessageAdherence[] = [];
  @Input() flattenedSections: IFlattenedMessageAdherenceSection[] = [];
  @Input() isMessageAdherenceV2: boolean = false;
  @Input() isUserCompliant: boolean | null = null;
}
